<template>
    <el-card class="box-card" sytle="padding: 5px;">
        <!-- 表单只有一个文本框的时候，按回车会自动submit表单，需要禁用sunmit -->
        <el-form
            ref="searchform"
            :inline="true"
            :model="form"
            @submit.native.prevent
            size="medium"
        >
            <el-form-item label="玩家昵称" prop="name">
                <el-input
                    v-model="form.name"
                    placeholder="玩家昵称"
                    @keyup.enter.native="search()"
                    clearable
                    class="name_c"
                ></el-input>
            </el-form-item>
            <el-form-item label="使用角色" prop="role">
                <el-input
                    v-model="form.role"
                    placeholder="角色名"
                    @keyup.enter.native="search()"
                    clearable
                    class="role_c"
                ></el-input>
            </el-form-item>
            <el-form-item label="模式">
                <el-select
                    v-model="form.mode"
                    placeholder="全模式"
                    clearable
                    class="mode_c"
                >
                    <el-option
                        v-for="item in AllMode"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="阵营">
                <el-select
                    v-model="form.identity"
                    placeholder="全阵营"
                    clearable
                    class="identity_c"
                >
                    <el-option
                        v-for="item in AllIdentity"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="结局">
                <el-select
                    v-model="form.finish"
                    placeholder="胜败"
                    clearable
                    class="mode_c"
                >
                    <el-option
                        v-for="item in AllFinish"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="存活">
                <el-select
                    v-model="form.is_dead"
                    placeholder=""
                    clearable
                    class="mode_c"
                >
                    <el-option
                        v-for="item in AllIsDead"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="规则">
                <el-select
                    v-model="form.rule"
                    placeholder=""
                    clearable
                    class="rule_c"
                >
                    <el-option
                        v-for="item in AllRule"
                        :key="item.id"
                        :label="item.name"
                        :value="item.code"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="对局时间">
                <el-date-picker
                    v-model="form.starttime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="所有时间"
                    class="time_c">
                </el-date-picker>
                至
                <el-date-picker
                    v-model="form.endtime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="所有时间"
                    class="time_c">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" plain @click="search">搜索</el-button>
                <el-button type="warning" plain @click="resetbtn()">重置</el-button>
            </el-form-item>
        </el-form>
    </el-card>
</template>

<script>
export default {
    name: 'GameRecordMySearchBarComponent',
    data() {
        return {
            fdialogFormVisible: false,
            form: {
                name: this.$store.state.user.name,
                role: '',
                mode:'',
                identity: '',
                finish: '',
                is_dead: '',
                rule: '',
                starttime: '',
                endtime: '',
                page: 1
            }
        }
    },
    computed: {},
    methods: {
        search() {
            this.$emit('search', this.form)
        },
        resetbtn(f) {
            this.form = {
                name: this.$store.state.user.name,
                role: '',
                mode:'',
                identity: '',
                finish: '',
                is_dead: '',
                rule: '',
                starttime: '',
                endtime: '',
                page: 1
            }
        }
    },
    filters: {},
    props: {
        AllMode: {
            type: Array,
            default() {
                return []
            }
        },
        AllIdentity: {
            type: Array,
            default() {
                return []
            }
        },
        AllFinish: {
            type: Array,
            default() {
                return []
            }
        },
        AllIsDead: {
            type: Array,
            default() {
                return []
            }
        },
        AllRule: {
            type: Array,
            default() {
                return []
            }
        }
    },
    created() {},
    destoryed() {},
    mounted() {},
    updated() {},
    components: {},
    watch: {},
}
</script>

<style lang='less' scoped>
.box-card .el-form-item {
    margin-bottom: 3px;
}
.name_c {
    width: 160px;
}
.role_c {
    width: 120px;
}
.mode_c,.identity_c {
    width: 100px;
}
.time_c {
    width: 150px;
}
.rule_c {
    width: 120px;
}
</style>